<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-2" style="height: 350px">
    <!-- Header -->
    <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
      <v-card-text class="pa-0 ma-0 text-body-2"
        >{{ $t("bestSellingProducts") }}
      </v-card-text>
      <v-btn text small color="primary" class="ma-0 pa-0">
        {{ $t("viewAll") }}
        <v-icon small class="ma-0 pa-0">mdi-chevron-left</v-icon>
      </v-btn>
    </v-container>
    <!-- List -->
    <v-list v-if="hasData" dense class="pa-0 ma-0 scroll-y">
      <v-list-item
        v-for="(product, index) in ProductArray"
        :key="index"
        class="pa-0 ma-0"
      >
        <!-- Avatar -->
        <v-list-item-avatar size="40">
          <v-img v-if="product.avatar" :src="product.avatar" contain />
          <v-avatar v-else color="grey lighten-3" class="ma-0 pa-0">
            <v-icon class="ma-0 pa-0" color="grey"> mdi-account </v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <!-- Info -->
        <v-list-item-content>
          <v-list-item-title class="pa-0 py-1 ma-0 text-body-1">
            {{ product.product_name }}
          </v-list-item-title>

          <v-list-item-subtitle class="pa-0 py-1 ma-0 text-body-1 grey--text">
            {{ product.invoices }} {{ $t("sell") }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <!-- Amount + Growth -->
        <v-list-item-action>
          <v-container class="pa-0 ma-0 text-left">
            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ formatPrice(product.amount) }}{{ $store.state.currency.name }}
            </v-card-text>
            <v-card-text
              class="pa-0 ma-0 text-body-2 text-left"
              :class="product.trend == 'increase' ? 'green--text' : 'red--text'"
            >
              <v-icon
                class="pa-0 ma-0"
                small
                :color="product.trend == 'increase' ? 'green' : 'red'"
              >
                {{
                  product.trend == "increase"
                    ? "mdi-arrow-top-right"
                    : "mdi-arrow-bottom-right"
                }}
              </v-icon>

              {{ Math.abs(product.diffPercent) }} %
            </v-card-text>
          </v-container>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-container
      v-else
      class="pa-0 ma-0 d-flex flex-column align-center justify-center"
      style="height: 337px"
    >
      <img
        :src="require('@/assets/dashboard/no-data(3).png')"
        max-width="100"
        height="100"
        contain
        class="mb-3"
      />
      <v-card-text class="text-body-2 grey--text text-center">
        {{ $t("nothing-for-render") }}
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "TopProducts",

  data() {
    return {
      ProductArray: [],
    };
  },
  computed: {
    hasData() {
      return this.ProductArray.length > 0;
    },
  },
  mounted() {
    this.getTopProductData();
  },
  methods: {
    formatPrice(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },
    getTopProductData() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/top-products", {
          params: {
            dateType: "year",
          },
        })
        .then((response) => {
          console.log(response);
          let res = response.data.data.topProducts.sell;
          app.ProductArray = res.slice(-10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-scrollbar: none;
}
::v-deep .v-list-item__avatar:first-child {
  margin-left: 5px !important;
}
</style>
